import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class CampaignTotalCostProp extends Vue {
  @Prop({ required: false, default: 0 }) campaignTotalCost!: number;
}
